import * as ActionTypes from '../../actionTypes/cabinListActionTypes';

const initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_MESSAGE: {
      if (action.message) {
        return action.message;
      }
      return state;
    }
    default:
      return state;
  }
};
